<div class="spinner-wrapper" [ngClass]="{'active': pageLoading} ">
    <div class="spinner"></div>
</div>